import { Controller } from "@hotwired/stimulus"
import { lockBody, unlockBody } from "../shared/body_lock.js"

export default class extends Controller {
  static targets = ["panel", "overlay", "close"]

  connect() {
    this.isOpen = false
    this.keydownAttached = false
    this.boundOpen = this.open.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    this.openTriggers = document.querySelectorAll("[data-job-transactions-panel-open]")

    this.openTriggers.forEach((trigger) => {
      trigger.addEventListener("click", this.boundOpen)
    })

    // Turbo cache restore preserves panel CSS but reconnects Stimulus with isOpen=false.
    if (this.isPanelVisible()) {
      this.isOpen = true
      this.applyPanelOpenState()
      this.ensureKeydownListener()
      this.scheduleOpened()
    }
  }

  disconnect() {
    if (this.isOpen) this.close()

    this.openTriggers.forEach((trigger) => {
      trigger.removeEventListener("click", this.boundOpen)
    })
    this.removeKeydownListener()
  }

  open(event) {
    event?.preventDefault()
    this.isOpen = true
    this.applyPanelOpenState()
    this.ensureKeydownListener()
    this.scheduleOpened()
  }

  close(event) {
    event?.preventDefault()
    if (!this.isOpen) return

    this.isOpen = false
    this.panelTarget.classList.add("translate-x-full")
    unlockBody()
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none", "hidden")
    this.removeKeydownListener()
    this.dispatch("closed")
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  applyPanelOpenState() {
    this.panelTarget.classList.remove("translate-x-full")
    lockBody()
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none", "hidden")
  }

  scheduleOpened() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.dispatch("opened")
      })
    })
  }

  ensureKeydownListener() {
    if (this.keydownAttached) return

    document.addEventListener("keydown", this.boundHandleKeydown)
    this.keydownAttached = true
  }

  removeKeydownListener() {
    if (!this.keydownAttached) return

    document.removeEventListener("keydown", this.boundHandleKeydown)
    this.keydownAttached = false
  }

  isPanelVisible() {
    return !this.panelTarget.classList.contains("translate-x-full")
  }
}
